const $inject = ['$document', '$window'];
const clickOutside = function ($document, $window) {
  return {
    restrict: 'A',
    scope: {
      clickOutside: '&',
    },
    link: function (scope, el) {
      $document.on('click', eventHandler);

      scope.$on('$destroy', function () {
        $document.off('click', eventHandler);
      });

      function eventHandler(e) {
        if (e.currentTarget.activeElement.className != "lbSeatMaps_ctaRight"){
        if(e.currentTarget.activeElement.href)
        {
          if (e.currentTarget.activeElement.target == "") e.currentTarget.activeElement.target = "_self";
          window.open(e.currentTarget.activeElement.href, e.currentTarget.activeElement.target).focus();
        }}
        
        if (isHidden(el[0])) {
          return false;
        }

        if (el !== e.target && !el[0].contains(e.target)) {
          scope.$apply(function () {
            scope.$eval(scope.clickOutside);
          });
        }
      }

      function isHidden(element) {
        const style = $window.getComputedStyle(element);
        return style.display === 'none';
      }
    },
  };
};

clickOutside.$inject = $inject;

export default clickOutside;



// WEBPACK FOOTER //
// ./src/directives/lbClickOutside.js